export default __webpack_public_path__ + "static/media/product-04 (2).903bdb70.jpg";